exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_AAKrn6NRQfsl6fFYjAJn_1{background-color:transparent;border:0}.wFg8fKKIJgFXSG8qLrgrw_1{background-color:#a8daf1;border:0;bottom:0}", ""]);

// exports
exports.locals = {
	"layout_header": "_2_AAKrn6NRQfsl6fFYjAJn_1",
	"layout_footer": "wFg8fKKIJgFXSG8qLrgrw_1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"localIdentName":"[hash:base64]_1","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bb834d7","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./node_modules/iview-loader??ref--1-1!./src/App.vue
// module id = LBgq
// module chunks = 0